import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_BASE_URL, getAuthHeader } from '../../../services/api';

export const fetchUserDogs = createAsyncThunk(
  'dogs/fetchUser',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/dogs`, { headers: getAuthHeader() });
      return response.data.dogs || response.data;  // ensure array
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.msg || error.message);
    }
  }
);

// src/redux/slices/Dogs/dogSlice.js
export const fetchDogById = createAsyncThunk(
  'dogs/fetchById',
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/dogs/${id}`, { headers: getAuthHeader() });
      return response.data.dog; // adjust based on your API response structure
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.msg || error.message);
    }
  }
);

export const createDog = createAsyncThunk('dogs/create', async (dogData, thunkAPI) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/dogs`, dogData, { headers: getAuthHeader() });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.msg || error.message);
  }
});

export const updateDog = createAsyncThunk(
  'dogs/update',
  async ({ id, dogData }, thunkAPI) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/dogs/${id}/update`, dogData, {
        headers: getAuthHeader(),
      });
      return response.data.dog; // assuming response contains dog
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.msg || error.message);
    }
  }
);

export const deleteDog = createAsyncThunk('dogs/delete', async (id, thunkAPI) => {
  try {
    await axios.delete(`${API_BASE_URL}/dogs/${id}`, { headers: getAuthHeader() });
    return id;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.msg || error.message);
  }
});

const initialState = { dogs: [], isLoading: false, error: null };
const dogSlice = createSlice({
  name: 'dogs',
  initialState,
  reducers: { clearDogError: (state) => { state.error = null; } },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDogs.pending, (state) => { state.isLoading = true; })
      .addCase(fetchUserDogs.fulfilled, (state, action) => { state.isLoading = false; state.dogs = action.payload; })
      .addCase(fetchUserDogs.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; })
      .addCase(createDog.fulfilled, (state, action) => { state.dogs.push(action.payload); })
      .addCase(updateDog.fulfilled, (state, action) => {
        const index = state.dogs.findIndex(d => d._id === action.payload._id);
        if (index !== -1) state.dogs[index] = action.payload;
      })
      .addCase(deleteDog.fulfilled, (state, action) => { state.dogs = state.dogs.filter(d => d._id !== action.payload); });
  },
});
export const { clearDogError } = dogSlice.actions;
export default dogSlice.reducer;